import { Component, OnDestroy, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuditLog } from '../model/audit-log.model';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.scss']
})
export class AuditLogComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['auditId', 'performedAt', 'performedBy', 'entityType', 'entityId', 'action', 'fieldName', 'oldValue', 'newValue', 'description'];

  logs: AuditLog[] = [];
  isLoading = false;

  // Server-side pagination state
  totalElements = 0;
  pageIndex = 0;
  pageSize = 25;

  // Filters — every change reloads page 0 from the server
  searchValue = '';
  entityType = '';
  action = '';
  fromDate = '';
  toDate = '';
  includeRoutine = false;

  entityOptions = [
    { value: 'CUSTOMER', label: 'Customer' },
    { value: 'EMPLOYEE', label: 'Employee' },
    { value: 'Meter', label: 'Meter' },
    { value: 'Bill', label: 'Bill' },
  ];
  actionOptions = [
    { value: 'CREATE', label: 'Create' },
    { value: 'UPDATE', label: 'Update' },
    { value: 'DELETE', label: 'Delete' },
    { value: 'DATE_UPDATE', label: 'Date Update' },
  ];

  private searchTimer: any;

  constructor(private apiService: ApiService, private snackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.loadLogs();
  }

  ngOnDestroy(): void {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  }

  loadLogs(): void {
    this.isLoading = true;
    this.apiService.getAuditLogs({
      page: this.pageIndex,
      size: this.pageSize,
      entityType: this.entityType,
      action: this.action,
      from: this.fromDate,
      to: this.toDate,
      search: this.searchValue,
      includeRoutine: this.includeRoutine,
    }).subscribe(
      (page: any) => {
        this.logs = page?.content || [];
        this.totalElements = page?.totalElements || 0;
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
        this.snackBar.open('Error loading audit logs', 'Close', { duration: 3000 });
      }
    );
  }

  onPage(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadLogs();
  }

  // Selects / dates / checkbox reload immediately on page 0
  onFilterChange(): void {
    this.pageIndex = 0;
    this.loadLogs();
  }

  // Text search is debounced so typing doesn't fire a request per key
  onSearchInput(): void {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    this.searchTimer = setTimeout(() => {
      this.pageIndex = 0;
      this.loadLogs();
    }, 400);
  }

  clearFilters(): void {
    this.searchValue = '';
    this.entityType = '';
    this.action = '';
    this.fromDate = '';
    this.toDate = '';
    this.includeRoutine = false;
    this.pageIndex = 0;
    this.loadLogs();
  }
}
